import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/customers',
    name: 'PUT_CUSTOMER',
    method: 'PUT',
  });

  return [exec, isRequestSuccessed];
});
